import React, { useEffect, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { GlobalContext } from '../context/GlobalState'

const Friends = () => {

  const context = useContext(GlobalContext)
  const navigate = useNavigate()
  const { user, users, getAllUsers, addFriend, removeFriend } = context

  useEffect (() => {
    if (user == null) {
      navigate('/login')
    }
    else {
      getAllUsers()
    }
  //eslint-disable-next-line
  }, [])

  // toggle user as friend or not
  const toggleUser = (friendID, friendStatus) => {
    console.log(friendID)
    if(friendStatus === 'Y')
      removeFriend(friendID)
    else
      addFriend(friendID)
  }

  return (
    <div className="all-pages-bg">
      <Header style={'mini'} />
      <div className="list-content">
        <div className="list-info">
          <h5>Favorites</h5>
          <p>Update your favorites list</p>
        </div>
        <div className = "">
          {users.filter(user => user.friend === 'Y' ).map(friend => (
            <div className="friend-list-container" key={friend.userID}>
              <i className={`fas fa-user${friend.avatar}`}></i>
              <div className="friend-list-info">
                <p>Username: {friend.username}</p>
                <p>Name: {friend.fname} {friend.lname}</p>
                <a href={"mailto:" + friend.email}>{friend.email}</a>
              </div>
              <i className="fas fa-heart favorite-icon friend-color"
                onClick={() => toggleUser(friend.userID, friend.friend)}
              >
              </i>
            </div>
          ))}
        </div>

        <div className="list-info" style={{marginTop: '2em'}}>
          <h5>Users</h5>
          <p>All other users</p>
        </div>
        <div className = "">
          {users.filter(user => user.friend !== 'Y' ).map(otherUser => (
            <div className="friend-list-container" key={otherUser.userID}>
              <i className={`fas fa-user${otherUser.avatar}`}></i>
              <div className="friend-list-info">
                <p>Username: {otherUser.username}</p>
                <p>Name: {otherUser.fname} {otherUser.lname}</p>
                <a href={"mailto:" + otherUser.email}>{otherUser.email}</a>
              </div>
              <i className="fas fa-heart favorite-icon"
                onClick={() => toggleUser(otherUser.userID, otherUser.friend)}
              >
              </i>
            </div>
          ))}
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Friends